<template>
  <!-- The pictures and files of a message (a voice message has its own
       player). Pictures are thumbnails that open the viewer; files are cards
       that open or download in a new tab. -->
  <div class="sc-files" :class="{ 'sc-files--mine': mine }">
    <div v-if="images.length" class="sc-gallery" :class="`sc-gallery--${Math.min(images.length, 4)}`">
      <button
        v-for="(image, index) in visibleImages"
        :key="image.key || image.url || index"
        type="button"
        class="sc-gallery__item"
        :title="image.name"
        :aria-label="`Open ${image.name || 'picture'}`"
        @click="$emit('open-image', { images, index })"
      >
        <img :src="image.url" :alt="image.name || 'Picture'" loading="lazy" @error="markBroken(image)" />
        <span v-if="index === visibleImages.length - 1 && hiddenCount" class="sc-gallery__more">+{{ hiddenCount }}</span>
      </button>
    </div>
    <ul v-if="files.length" class="sc-filecards">
      <li v-for="(file, index) in files" :key="file.key || file.url || index">
        <a class="sc-filecard" :href="file.url" target="_blank" rel="noopener" :title="file.name" @click="onFileClick($event, file)">
          <span class="sc-filecard__icon"><i class="pi" :class="chatFileIcon(file)" aria-hidden="true"></i></span>
          <span class="sc-filecard__meta">
            <span class="sc-filecard__name">{{ file.name || 'File' }}</span>
            <span class="sc-filecard__size">{{ fileDetail(file) }}</span>
          </span>
          <i class="pi pi-download sc-filecard__dl" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { chatFileIcon, fileExtension, formatFileSize, isChatImage } from '@/utils/chat';

const MAX_THUMBNAILS = 4;

export default {
  name: 'ChatAttachments',
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    mine: {
      type: Boolean,
      default: false,
    },
    // Still uploading: the files are on this device only.
    local: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['open-image'],
  data() {
    return {
      // Pictures the browser could not draw, shown as files instead.
      broken: {},
    };
  },
  computed: {
    images() {
      return this.attachments.filter((file) => this.isPicture(file));
    },
    visibleImages() {
      return this.images.slice(0, MAX_THUMBNAILS);
    },
    hiddenCount() {
      return Math.max(this.images.length - MAX_THUMBNAILS, 0);
    },
    files() {
      return this.attachments.filter((file) => !this.isPicture(file) && file.kind !== 'voice');
    },
  },
  methods: {
    chatFileIcon,
    isPicture(file) {
      return file.kind !== 'voice' && (file.kind === 'image' || isChatImage(file.name, file.mimetype)) && !this.broken[file.url];
    },
    markBroken(file) {
      this.broken = { ...this.broken, [file.url]: true };
    },
    fileDetail(file) {
      const size = formatFileSize(file.size);
      const type = fileExtension(file.name).replace('.', '').toUpperCase();
      return [type, size].filter(Boolean).join(' · ') || 'File';
    },
    // A file still uploading has nowhere to open yet.
    onFileClick(event) {
      if (this.local) event.preventDefault();
    },
  },
};
</script>
